export default {
  computed: {
    hasOneOrMoreItems() {
      try {
        return this.items.length >= 1
      } catch {
        return false
      }
    },
    hasMoreItemsThanLimit() {
      try {
        if (this.noLimit) return false
        return this.items.length > this.limit
      } catch {
        return false
      }
    },
    hiddenCount() {
      try {
        return this.items.length - this.limit
      } catch {
        return 0
      }
    },
    hiddenItemsText() {
      try {
        return `+ ${this.hiddenCount} more`
      } catch {
        return ''
      }
    },
    itemsToShow() {
      const show = []

      for (let i = 0; i < this.items.length; ++i) {
        if (i < this.limit || this.noLimit) {
          show.push(this.items[i])
        }
      }

      return show
    },
    hiddenItems() {
      const hidden = []

      for (let i = this.limit; i < this.items.length; ++i) {
        hidden.push(this.items[i])
      }

      return hidden
    },
    noLimit() {
      return this.limit === 0
    },
  },
  methods: {
    notFirstIndex(index) {
      return index !== 0
    },
  },
}
